import {
  checkHasEmptyFilter,
  checkHasEmptyFilterBefore,
  normalizeFilterPayload,
  extractFilterValuesForColumn as extractFilterValuesUtil,
  buildActiveFilters as buildActiveFiltersUtil,
  convertFilterOrderToFieldKeys as convertFilterOrderToFieldKeysUtil,
  handleGetParamsFilterWithFieldKey as handleGetParamsFilterWithFieldKeyUtil,
  formatFilterValues as formatFilterValuesUtil,
  FilterPayload,
} from "@lhd/hooks";

export type TargetTab = string;

export const isMaintenanceNoticeDateField = (columnId: string): boolean => {
  return (
    columnId.includes("date") ||
    columnId === "created_at" ||
    columnId === "updated_at" ||
    columnId === "maintenance_start_at" ||
    columnId === "maintenance_end_at"
  );
};

export const getFieldKey = (
  columnId: string,
  _targetTab?: TargetTab,
): string => {
  return columnId;
};

export const formatFilterValues = (
  columnId: string,
  values: string[],
): string[] => {
  return formatFilterValuesUtil(columnId, values, isMaintenanceNoticeDateField);
};

export const extractFilterValuesForColumn = (
  columnId: string,
  config: any,
): string[] => {
  return extractFilterValuesUtil(columnId, config, formatFilterValues);
};

export {
  checkHasEmptyFilter,
  checkHasEmptyFilterBefore,
  normalizeFilterPayload,
};

export const buildActiveFilters = (
  filter: Record<string, any> = {},
  _targetTab?: TargetTab,
): Record<string, string[]> => {
  return buildActiveFiltersUtil(
    filter,
    getFieldKey,
    extractFilterValuesForColumn,
  );
};

export const handleGetParamsFilterWithFieldKey = (
  filterInfo: any,
  _targetTab?: TargetTab,
): Record<string, any> => {
  const { filter = {} } = filterInfo;
  const params: Record<string, any> = {};
  const sortObj: Record<string, string> = {};

  Object.entries(filter).forEach(([columnId, config]: [string, any]) => {
    const fieldKey = getFieldKey(columnId);
    const filterKey = `active_filters[${fieldKey}][]`;

    const sort = config?.sort;
    if (sort === "asc" || sort === "desc") {
      sortObj[fieldKey] = sort;
    }

    const values = extractFilterValuesForColumn(columnId, config);
    if (values.length > 0) {
      params[filterKey] = values;
    }
  });

  if (Object.keys(sortObj).length > 0) {
    params.sort = sortObj;
  }

  return params;
};

export const convertFilterOrderToFieldKeys = (
  filterOrder: string[],
  _targetTab?: TargetTab,
): string[] => {
  return convertFilterOrderToFieldKeysUtil(filterOrder, getFieldKey);
};
